import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from '@/i18n/messages/en.js'
import jp from '@/i18n/messages/jp.js'
import zhTW from '@/i18n/messages/zhTW.js'

Vue.use(VueI18n)

const messages = {
  en: en,
  'zh-TW': zhTW,
  'jp': jp
}

const i18n = new VueI18n({
  locale: 'en',
  messages,
  fallbackLocale: 'en',
  silentFallbackWarn: false
})

export default i18n
